




























































































































































































import { ValidationObserver, ValidationProvider } from "vee-validate";
import { Component, Vue } from "vue-property-decorator";
import { PostsApi, PutPostRequest } from "../../../apis";
import i18n from "../../../locale";
import ConfirmDialog from "../user-management/ConfirmDialog.vue";

export enum ACTION {
  EDIT = "EDIT",
  DELETE = "DELETE",
}

@Component({
  components: { ValidationObserver, ValidationProvider, ConfirmDialog },
})
export default class EditInstruction extends Vue {
  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };
  itemsLanguage = ["English", "Tiếng Việt"];
  language = "English";
  imageUrlEn = "Image URL...";
  imageUrlVn = "Hình ảnh...";
  shortDescriptionEn = "";
  shortDescriptionVn = "";
  contentEn = "";
  contentVn = "";
  subjectVn = "";
  subjectEn = "";
  isAbout = true;
  idPostAbout = "";
  errorEdit = "";
  editorConfig = {
    extraPlugins: "colorbutton,colordialog,font,justify",
  };
  editorConfig2 = {
    extraPlugins: "colorbutton,colordialog,font,justify",
  };
  ckeditorEnLoaded = false;

  showConfirmDialog = false;
  errDialog = "";
  confirmContent = "";
  selectedAction: ACTION;
  selectedId: string;

  mounted() {
    this.selectedId = this.$route.params.id;
    this.getInstruction();
  }

  onDeleteInstruction() {
    this.selectedAction = ACTION.DELETE;
    this.showConfirmDialog = true;
    this.confirmContent = `${this.$t(
      "dialog.confirmInstruction.contentDelete"
    )}`;
  }

  onCancel() {
    this.$router.push({ name: "instructions" });
  }

  async getInstruction() {
    const res = await new PostsApi().getPost({
      id: this.selectedId,
    });
    const response = res.data.data[0];
    this.idPostAbout = response.id;
    this.imageUrlEn = response.headerUrlEn;
    this.imageUrlVn = response.headerUrlVn;
    this.shortDescriptionEn = response.shortDescriptionEn;
    this.shortDescriptionVn = response.shortDescriptionVn;
    this.subjectEn = response.subjectEn;
    this.contentEn = response.contentEn;
    this.contentVn = response.contentVn;
    this.subjectVn = response.subjectVn;
  }

  async updateInstruction() {
    try {
      this.$util.showLoading();
      const body = {
        subjectEn: this.subjectEn,
        headerUrlEn: this.imageUrlEn,
        headerUrlVn: this.imageUrlVn,
        shortDescriptionEn: this.shortDescriptionEn,
        subjectVn: this.subjectVn,
        shortDescriptionVn: this.shortDescriptionVn,
        contentVn: this.$refs["ckeditorVi"].instance.document
          .getBody()
          .getHtml(),
        contentEn: this.$refs["ckeditorEn"].instance.document
          .getBody()
          .getHtml(),
        isAbout: false,
      } as PutPostRequest;
      const res = await new PostsApi().updatePost({
        id: this.idPostAbout,
        putPostRequest: body,
      });
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
      this.$router.push({ name: "instructions" });
    }
  }

  onPublicInstruction() {
    if (this.contentVn.length > 0 && this.contentEn.length > 0) {
      (this as any).$refs.observer.validate().then((success) => {
        if (!success) {
          return;
        }
        this.updateInstruction();
        this.errorEdit = "";
      });
    } else {
      return (this.errorEdit = i18n
        .t("message.empty_content_about")
        .toString());
    }
  }

  onCancelDialog() {
    this.errDialog = "";
  }

  onOkConfirmDialog() {
    if (this.selectedAction === ACTION.DELETE) {
      this.delete();
    }
  }

  async delete() {
    const id = this.selectedId;
    this.$util.showLoading();
    try {
      const rs = await new PostsApi().deletePost({
        id: id,
      });
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
      this.$router.push({ name: "instructions" });
    }
  }
}
